import type { AccountType, Notification } from '@witmetrics/utils';
import { ACCOUNT_TYPES } from '@witmetrics/utils/constants';
import {
  updateActiveAccount as coreUpdateActiveAccount,
  updateReadNotification as coreUpdateReadNotification,
} from '@witmetrics/unison-core';
import { API } from '@/api';
import { getAuthUrl } from '@/api/urls';
import { useSessionStorage } from '@/hooks/useStorage';

const { PRACTICE, LAB } = ACCOUNT_TYPES;

export function useStoredAccountId() {
  return useSessionStorage<number | null>('activeAccountId', null, true);
}

export const updateActiveAccount = (
  accountType: AccountType,
  accountId: number
) => coreUpdateActiveAccount(API, accountType, accountId);

export const updateReadNotification = (notificationId: number) =>
  coreUpdateReadNotification(API, notificationId);

export function redirectToPlatformSelector() {
  window.location.assign(getAuthUrl());
}

export function warnBeforeUnload(e: BeforeUnloadEvent) {
  e.preventDefault();
  e.returnValue = '';
}

export function getNotificationAccount(notification: Notification) {
  if (notification.practiceId) {
    return { accountType: PRACTICE, accountId: notification.practiceId };
  }
  return { accountType: LAB, accountId: notification.labId! };
}
